import { call, put } from 'redux-saga/effects';
import { apiGeneral, notify } from 'services';
import { IUpdateRequest } from 'interfaces/update-duck';
import { requestErrorHandler } from 'utils';
import { UpdateCarrierContactActions } from 'store/ducks/settings/carrier-contact';

export function* updateCarrierContactRequest(action: any) {
  try {
    const { id, putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.put,
      `/carrier-contact/${id}`,
      putData
    );

    const { data } = responseBody;
    yield put(UpdateCarrierContactActions.success(data));
    notify('success', 'Contato atualizado com sucesso');
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(UpdateCarrierContactActions.failure(errorMessage));
  }
}
